import { soFormInitialValue } from 'src/vars'

export default function () {
  return {
    form: { ...soFormInitialValue },
    paymentMethodPrevValue: null,
    revertPaymentMethodPrevValue: false
  }
}
